// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J1S55xmjIKEP4lgitw4u{height:100%;margin-right:-20px;padding:24px 0;overflow:hidden}.j6mIzH7E9eEcCyyJ8aTB{flex-direction:column;gap:16px;padding-right:20px;display:flex}.y66oEWn8LY8OSgLX6ODd{max-height:100%!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `J1S55xmjIKEP4lgitw4u`,
	"scrollbar__content": `j6mIzH7E9eEcCyyJ8aTB`,
	"scrollbarContent": `j6mIzH7E9eEcCyyJ8aTB`,
	"scrollbar__view": `y66oEWn8LY8OSgLX6ODd`,
	"scrollbarView": `y66oEWn8LY8OSgLX6ODd`
};
export default ___CSS_LOADER_EXPORT___;
